// ─────────────────────────────────────────────────────────────────────────────
// metaPixel.js – Meta (Facebook) Pixel loader
//
// GDPR compliance:
//  - Skript sa NIKDY nenahrá pred explicitným marketingovým súhlasom.
//  - Pri odvolaní súhlasu sa Pixel zastaví (fbq consent revoke) a _fbp/_fbc
//    cookies sa vymažú.
//  - Pixel beží iba na produkčnej doméne.
// ─────────────────────────────────────────────────────────────────────────────

const PIXEL_ID = "2281126922687722";
const PROD_HOSTNAME = "capoeira.sk";

let initialized = false;

/**
 * Dynamicky injektuje Meta Pixel a odošle PageView.
 * Volajte VÝHRADNE po získaní marketing súhlasu.
 */
export function initMetaPixel() {
  if (window.location.hostname !== PROD_HOSTNAME) return;

  if (initialized) {
    // Súhlas bol predtým odvolaný a znova udelený
    window.fbq("consent", "grant");
    return;
  }

  if (!window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  window.fbq("consent", "grant");
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");

  initialized = true;
}

/**
 * Zastaví Meta Pixel a vymaže jeho cookies.
 * Volajte pri odvolaní marketing súhlasu.
 */
export function revokeMetaPixel() {
  if (typeof window.fbq === "function") {
    window.fbq("consent", "revoke");
  }

  const domain = window.location.hostname;
  const rootDomain = domain.split(".").slice(-2).join(".");

  ["_fbp", "_fbc"].forEach((name) => {
    [domain, `.${domain}`, `.${rootDomain}`].forEach((d) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${d}`;
    });
  });
}
